'use client'
import React, { useEffect } from 'react'

type BackDropProps = {
  backdropType?: 'backdrop' | 'image-detail-backdrop'
  onClick?: () => void
  isOpen: boolean
}

const BackDrop = ({ backdropType = 'backdrop', onClick, isOpen }: BackDropProps) => {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = originalOverflow
    }
  }, [isOpen])

  return isOpen ? <div className={backdropType} onClick={onClick}></div> : <></>
}

export default BackDrop
